import { ADS_API, API } from "@/utils/http"

export const getUserData = () => {
  return Promise.all([API.get("/v2/seller/profile"), API.get("/v2/customer/profile")])
}

export const getBalance = () => {
  return ADS_API.get("/v1/backoffice/profile/")
}
